import { render } from "./SearcherBar.vue?vue&type=template&id=3ac48b82"
import script from "./SearcherBar.vue?vue&type=script&lang=js"
export * from "./SearcherBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__